import { useEffect, useState } from "react";
import { endpoints } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = "bbk_fb_favs";
const EMPTY = { teams: [], competitions: [], matches: [] };
const read = () => { try { return { ...EMPTY, ...(JSON.parse(localStorage.getItem(KEY)) || {}) }; } catch { return EMPTY; } };

let state = read();
let syncedFor = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f(state));
const persist = (next, push) => {
  state = next;
  localStorage.setItem(KEY, JSON.stringify(state));
  emit();
  if (push && localStorage.getItem("bbk_token")) endpoints.saveFbFavs(state).catch(() => {});
};
const merge = (a, b) => {
  const out = {};
  for (const k of Object.keys(EMPTY)) {
    const seen = new Map();
    [...(a[k] || []), ...(b[k] || [])].forEach((x) => seen.set(String(x.id), x));
    out[k] = [...seen.values()];
  }
  return out;
};

// Favourites (teams / competitions / matches): kept on the device and synced to the account.
export function useFbFavs() {
  const { user } = useAuth();
  const [favs, setFavs] = useState(state);
  useEffect(() => { subs.add(setFavs); return () => { subs.delete(setFavs); }; }, []);
  useEffect(() => {
    const uid = user?.id || user?._id;
    if (!uid || syncedFor === uid) return;
    syncedFor = uid;
    endpoints.myFbFavs().then((r) => {
      const merged = merge(r.data || EMPTY, state);
      const changed = JSON.stringify(merged) !== JSON.stringify(r.data || EMPTY);
      persist(merged, changed);
    }).catch(() => { syncedFor = null; });
  }, [user]);

  const isFav = (kind, id) => (favs[kind] || []).some((x) => String(x.id) === String(id));
  const toggle = (kind, item) => {
    const list = state[kind] || [];
    const has = list.some((x) => String(x.id) === String(item.id));
    persist({ ...state, [kind]: has ? list.filter((x) => String(x.id) !== String(item.id)) : [...list, item] }, true);
  };
  return { favs, isFav, toggle };
}
